
function OnRepeatFinishDirective($timeout, $parse, $rootScope) {
    return {
        restrict: 'A',
        link(scope, element, attr) {

            function notify() {
                $rootScope.$broadcast('ngRepeatFinished');
                if (!!attr.onFinishRender) {
                    $parse(attr.onFinishRender)(scope);
                }
            }

            if (scope.$last === true) {
                $timeout(notify);
            }
        }
    };
}


module.exports = OnRepeatFinishDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/on-repeat-finish/on-repeat-finish-directive.js
 **/